import api from './api';
import types from './mutation-types';

export default {
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	getPopupPqyCpnys_({ commit, state }) {
		const { searchParams, pagingInfo } = state;
		return api
			.getPopupPqyCpnys({ searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit })
			.then(data => {
				if (data.header.code === 0) {
					// 기존 정상 처리
					const { pagingInfo, resultList } = data.body;
					commit(types.PQY_CPNY_LIST, data !== null && data !== undefined ? resultList : null);
					commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
					// http status 는 성공이지만 내부적으로 오류일경우 catch 로 빠지게 하는식으로?
					// throw data
					// const { pagingInfo, resultList } = data.body;
					// commit(types.USER_LIST, data !== null && data !== undefined ? resultList : null);
					// commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
					// commit(types.DEFAULT_ASSIGN, { key: 'userList', value: resultList });
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				// console.log('@@@@ here catch: ', error);
				throw error.header ? error.header : error;
			});
	}
};
